import request from '@/utils/request'

const prefix = '/django_rest/company/potential'

export default {
  getCompanyPotentialCandidateList (params) {
    return request.get(`${prefix}/`, { params })
  },
  getCandidateReferralChain (params) {
    return request.get(`${prefix}/candidate/job/referral-chain/`, { params })
  },
  getPotentialCandidateIdList (params) {
    return request.get(`${prefix}/all-potential-ids/`, { params })
  },
  getPotentialCandidateBaseInfo (potentialId) {
    return request.get(`${prefix}/${potentialId}/base-info/`)
  },
  getPotentialCandidateResumeInfo (potentialId) {
    return request.get(`${prefix}/${potentialId}/resume/`)
  },
  getPotentialCandidateActivityInfo (potentialId) {
    return request.get(`${prefix}/${potentialId}/activity/`)
  },
  getPotentialCandidateTagInfo (params) {
    return request.get(`${prefix}/${params.potentialId}/tag/`, { params })
  },
  getPotentialCandidateSurveyInfo (potentialId) {
    return request.get(`${prefix}/${potentialId}/survey/`)
  }
}
